import React from "react";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";
import { MigrateNeptuneContent } from "../Component/MigrateNeptuneContent";

const MigrateNeptune = () => {
  const seoData = getSEOData("/migrate-neptune");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <MigrateNeptuneContent />
    </>
  );
};

export default MigrateNeptune;
